// --------------------------------------------------------------------------
// file to keep most of the text shown in the UI together
// --------------------------------------------------------------------------

import React from 'react';

// --------------------------------------------------------------------------

let words = {
    'default': {
        
        buttonStartScanning             : 'Start scanning',
        
        headingRequestingCameraAccess   : 'Scanning',
        textRequestingCameraAccess      : 'Requesting camera access',
        htmlRequestingCameraAccess      : <p>To allow access permanently please go to your browser settings here and select "Always Allow"</p>,

        buttonChangeLens                : 'Wrong camera lens? Try another',
        buttonExitBottleScanner         : 'Exit bottle scanner',
        buttonSearch                    : 'Search',

        headingScanning                 : 'Scanning',
        textScanning                    : 'Searching for barcode',
        textFailure                     : 'Barcode not recognised',
        textSkipping                    : 'Barcode not recognised...', // the dots are so WE know

        headingMultipleResults          : 'Your scanning result',
        textMultipleResults             : 'We found multiple results, please choose from the list below',
        
        headingSingleResult             : 'Your scanning result',
        buttonViewProductPage           : 'View product page and buy',
        buttonViewTastingNotes          : 'Go beyond the label',
        buttonReselectWine              : 'Return to list',        
        buttonTryAgain                  : 'Try again',

        headingSuggestSearchInstead     : 'Your scanning result',
        textSuggestSearchInstead        : 'Unfortunately no results were found. Please continue to scan or search for your wine below',

        headingNoInternet               : 'No internet',
        textNoInternet                  : 'Please connect to the internet and try again',
        buttonRetryInternet             : 'Try again'
        
    }
};

// --------------------------------------------------------------------------

function lookup(phrase,lang) {
    let dict = words[lang] || words['default'];
    return dict[phrase] || words['default'][phrase] || phrase;
}

// --------------------------------------------------------------------------

export default lookup;

// --------------------------------------------------------------------------